import React, { useState } from 'react';
import { useHistory, useLocation, Link } from "react-router-dom";
import { Layout, Menu, Image, Space, Button, Row, Col, Grid, Drawer } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import Logo from '../../../assets/img/WCHSS.png';
const { useBreakpoint } = Grid;
const { Header } = Layout;

function Headers() {
  const [visible, setVisible] = useState(false);
  
  let history = useHistory()
  let location = useLocation()
  let { xs, xxl } = useBreakpoint()
  
  const handleMenu = (e) => {
    history.push(e.key)
    setVisible(false)
  }

  const showDrawer = () => {
    setVisible(true)
  };

  const onClose = () => {
    setVisible(false)
  };
  
  const items = [
    { label: 'Home', key: '/' },
    { label: 'About', key: '/about' },
    { label: 'Call For Papers', key: '/call-for-papers' },
    { label: 'Sponsorship', key: '/sponsorship' },
    { label: 'Publications', key: '/publications' },
    { label: 'Contact Us', key: '/contact-us' }
  ]
  
  return (
    <Header className='header' style={{ height: 80, boxShadow: location.pathname === '/' ? null : '1px 4px 4px 1px #f2f2f2' }}>
      <Row justify="space-around" align="middle" style={{ padding: xxl ? '0 230px' : 0, margin: 0 }}>
        <Col xxl={2} lg={4} xs={8}>
          <Image
            width={'100%'}
            src={ Logo }
            preview={false}
          />
        </Col>
        <Col xxl={20} lg={20} xs={16}>
          {
            xs ?
              <Space style={{ float: 'right' }}>
                <Link to='/registration/info-and-payment-method'>
                  <Button className='button-registration'>Registration</Button>
                </Link>
                <Button size='large' icon={<MenuOutlined />} onClick={showDrawer} style={{ borderRadius: 4 }} />
              </Space>
            :
              <Space style={{ float: 'right' }}>
                <Menu
                  mode="horizontal"
                  defaultSelectedKeys={['/']}
                  selectedKeys={location.pathname}
                  onClick={handleMenu}
                  items={items}
                  style={{ width: 647, height: 80, paddingTop: 8 }}
                />
                <Link to='/registration/info-and-payment-method'>
                  <Button className='button-registration'>Registration</Button>
                </Link>
              </Space>

          }
        </Col>
      </Row>
      <Drawer
        placement="right"
        closable={false}
        onClose={onClose}
        visible={visible}
        width={'50%'}
        bodyStyle={{ padding: 0 }}
      >
        <Menu
          mode="vertical"
          defaultSelectedKeys={['/']}
          selectedKeys={location.pathname}
          onClick={handleMenu}
          items={items}
        />
      </Drawer>
    </Header>
  )
}

export default Headers